export default "__VITE_ASSET__143cb46c__"